import { Component, OnInit, Input } from '@angular/core';
import { SidebarService } from '@ibe/services/ui';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-economyxtra-details',
  templateUrl: './economyxtra-details.indra.component.html',
  styleUrls: ['./economyxtra-details.scss']
})
export class INDRAEconomyxtraDetailsComponent implements OnInit {
	photosGallery;
	isLongHaul: boolean;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
	) { }

	ngOnInit() {
		this.route.params.subscribe(params => {
			// tslint:disable-next-line: no-eval
			this.isLongHaul = eval(params.longhaul);
		});

		if (this.isLongHaul) {
			this.photosGallery = [{
				src: 'assets/images/economyxtra/lh_slide-00.jpg',
				label: 'Extra legroom and reclination'
			}, {
				src: 'assets/images/economyxtra/lh_slide-01.jpg',
				label: 'Extra legroom'
			}, {
				src: 'assets/images/economyxtra/lh_slide-02.jpg',
				label: 'In seat power outlets & USB ports'
			}, {
				src: 'assets/images/economyxtra/lh_slide-03.jpg',
				label: 'Onboard entertainment'
			}, {
				src: 'assets/images/economyxtra/lh_slide-04.jpg',
				label: 'Free seat reservation'
			}
			// , {
			// 	src: 'assets/images/economyxtra/mlh_slide-05.jpg',
			// 	label: 'Priority onboarding'
			// }
		];
		} else {
			this.photosGallery = [{
			// 	src: 'assets/images/economyxtra/mh_slide-00.jpg',
			// 	label: 'Premium meals'
			// }, {
				src: 'assets/images/economyxtra/mh_slide-01.jpg',
				label: 'Free seat reservation'
			}, 
			// {
			// 	src: 'assets/images/economyxtra/mh_slide-02.jpg',
			// 	label: 'Extra meals'
			// }, 
			{
				src: 'assets/images/economyxtra/mh_slide-03.jpg',
				label: 'In seat power outlets & USB ports'
			}, {
				src: 'assets/images/economyxtra/mh_slide-04.jpg',
				label: 'Tablet support'
			// }, {
			// 	src: 'assets/images/economyxtra/mlh_slide-05.jpg',
			// 	label: 'Priority onboarding'
			}];
		}
	}

	TAP_handleClose() {
		this.sidebarService.closeSidebar();
	}
}
